import { showBankApprovalToast } from "@replohq/agent-billing/components/showBankApprovalToast";
import {
  agentBillingRouter,
  agentBillingUtils,
} from "@v2/trpc/routes/agentBilling";
import { workspaceUtils } from "@v2/trpc/routes/workspace";

const useAgentApplySubscriptionChangeMutation = () => {
  const {
    mutateAsync: applySubscriptionChange,
    mutate: startSubscriptionChange,
    isPending,
    data,
  } = agentBillingRouter.checkout.createUpdateSubscriptionSession.useMutation({
    onSuccess: (data) => {
      void workspaceUtils.getUserWorkspacesList.invalidate();
      void agentBillingUtils.subscription.find.invalidate();
      void agentBillingUtils.subscription.findRateCards.invalidate();
      void workspaceUtils.getPublishedElementsUsage.invalidate();
      void workspaceUtils.getReploSitesUsage.invalidate();
      void workspaceUtils.getShopifyThemeProjectsUsage.invalidate();

      if (!data.confirmationRequired || !data.confirmationUrl) {
        return;
      }
      if (data.confirmationKind === "bankApproval") {
        showBankApprovalToast({
          url: data.confirmationUrl,
          onReturn: () => void agentBillingUtils.invalidate(),
        });
        return;
      }
      window.location.href = data.confirmationUrl;
    },
  });

  return {
    applySubscriptionChange,
    // Errors go to the global tRPC handler only, so callers need no try/catch.
    startSubscriptionChange,
    isLoading: isPending,
    data,
  };
};

export default useAgentApplySubscriptionChangeMutation;
